module.exports = __webpack_public_path__ + "assets/icon_jd_power.e7284af1.svg";